/// <amd-module name="Build/Admin/PoolsList/Stores/AgentPoolStore" />
import { Store } from "VSS/Reflux/Store";

import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";

import { TaskAgentPool } from "DistributedTask/Client/Contracts/TaskAgent";

export class AgentPoolStore extends Store {
    public state: TaskAgentPool[] = [];

    constructor() {
        super("AgentPoolStoreChanged");
    }

    public getAgentPoolById(taskAgentPoolId: number): TaskAgentPool | undefined {
        const matchingAgentPools: TaskAgentPool[] = this.state.filter(agentPool => agentPool.id === taskAgentPoolId);
        return matchingAgentPools[0];
    }

    public updateAgentPools = (agentPools: TaskAgentPool[]) => {
        this.state = this._sortAgentPools(agentPools.slice(0));
        this.emitChanged();
    }

    public addOrUpdateAgentPool = (agentPool: TaskAgentPool) => {
        // If an existing pool with this ID exists, filter it out
        const allOtherPools = this.state.filter(pool => pool.id !== agentPool.id);

        // Now add the new object and re-sort
        this.state = this._sortAgentPools(allOtherPools.concat([agentPool]));
        this.emitChanged();
    }

    public deleteAgentPool = (agentPool: TaskAgentPool) => {
        this.state = this.state.filter(pool => pool.id !== agentPool.id);
        this.emitChanged();
    }

    private _sortAgentPools(agentPools: TaskAgentPool[]): TaskAgentPool[] {
        return (agentPools).sort((a, b) => {
            return localeIgnoreCaseComparer(a.name, b.name);
        });
    }
}
